import errorProcessor from '@frontend/ll-fe-tracker/errorProcessor'

export default (graphqlError, { store, error, redirect, route }) => {
  errorProcessor.capture(`graphqlError ${graphqlError}`, { errorLocation: 'apollo/customErrorHandler' })
  const { message } = graphqlError

  // handle error
  return error({ message })
}
